import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
const lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const AttachmentPreferencesOption: LazyOption = createLazyOption(
    {
        key: 'attachmentPreferences',
        titleStringKey: 'optionTitle_attachmentPreferences',
        searchTermsStringKey: 'optionTitle_attachmentPreferences',
        allowedOptionKeys: ['AttachmentPreferences', 'AttachmentOptions'],
    },
    lazyFullModule,
    m => m.default
);
export default AttachmentPreferencesOption;
